// extracted by mini-css-extract-plugin
export default {"container":"oda-z","heading":"pda-z","links":"qda-z","linkBtn":"rda-z","disabled":"sda-z","linkUppercaseBold":"tda-z","copy":"uda-z","subCopy":"vda-z"};